import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionType from 'utils/mw/actionType.util';
import asObject from 'utils/objects/asObject.util';

const ATAG = 'beTimeOffAllowances';
const AT = actionType(ATAG);

const beTimeOffAllowances = (options) =>
  endpoint(H.get, 'salon/v2/:salonId/time_off_allowances/', {
    AT,
    name: ATAG,
    params: { salonId: asObject(options).salonId },
  });

beTimeOffAllowances.AT = AT;
beTimeOffAllowances.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beTimeOffAllowances;
